import { useQuery } from '@tanstack/react-query';

import { apiRequest } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useBookingsCsvDownload(params: {
  hotelId: number;
  enabled: boolean;
  search?: string;
  sorting?: string;
  beginning?: string;
  ending?: string;
  status?: string[];
  vccStatus?: string[];
  packageIds?: number[];
}) {
  const { hotelId, enabled, ...filters } = params;

  return useQuery({
    queryKey: ['bookings-csv', hotelId, filters],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.downloadBookingsCsv,
        params: {
          hotelId: hotelId.toString(),
          ...filters,
        },
      }),
    enabled: !!hotelId && enabled,
  });
}
